/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import { observer } from 'mobx-react-lite';

import { Button, Grid, Typography } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { translate } from 'utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping } from '@fortawesome/sharp-regular-svg-icons';
import { useModal } from 'hooks';
import { ROUTES } from 'utils/constants';

const PageSubscriptionDescription = observer(() => {
  const showModal = useModal();
  const history = useHistory();

  const handleSubmitModal = () => {
    history.push(ROUTES.SUBSCRIPTION);
  };

  const handleProceed = () => {
    showModal({
      type: 'RGPD',
      onProceed: handleSubmitModal
    });
  };
  return (
  <Grid container alignItems="center" spacing={3} wrap="wrap">
    <Grid item xs={12} sm={6}>
      <img
        alt="subscriptionDescription"
        src="/assets/images/bg/allo18-example.png"
        style={{ width: '100%', height: 'auto'}}
      />
    </Grid>

  <Grid item xs={12} sm={6}  >
    <Grid container direction="column" spacing={2}  style={{ paddingLeft: '16px', paddingRight: '16px' }}>
      <Grid item>
        <Typography className="bold" component="h2" variant="h4">
          {translate('subscription.descriptionTitle')}
        </Typography>
      </Grid>
      <Grid item>
        <Typography>{translate('subscription.descriptionText')}</Typography>
      </Grid>
      <Grid item>
        <Typography className="bold">{translate('subscription.descriptionQuestion')}</Typography>
      </Grid>
      <Grid item>
        <Typography>{translate('subscription.descriptionBullet0')}</Typography>
      </Grid>

      {/* Bullet 1 */}
      <Grid item>
        <Grid container spacing={1}>
          <Grid item>&bull;</Grid>
          <Grid item xs>{translate('subscription.descriptionBullet1')}</Grid>
        </Grid>
      </Grid>

      {/* Bullet 2 */}
      <Grid item>
        <Grid container spacing={1}>
          <Grid item>&bull;</Grid>
          <Grid item xs>{translate('subscription.descriptionBullet2')}</Grid>
        </Grid>
      </Grid>

      <Grid item>
        <Typography className="bold">{translate('subscription.descriptionFinal')}</Typography>
      </Grid>

      <Grid item>
        <Button color="primary" style={{ minWidth: '200px' }} onClick={handleProceed}>
          <Grid container spacing={1}>
            <Grid item>
              <FontAwesomeIcon icon={faCartShopping} />
            </Grid>
            <Grid item>{translate('subscription.proceedSubscription')}</Grid>
          </Grid>
        </Button>
      </Grid>
    </Grid>
  </Grid>
</Grid>
  );
});

export default PageSubscriptionDescription;